module.exports = __webpack_public_path__ + "img/bank-bg.917d0f6e.svg";